import $ from "jquery";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Msg from "../i18n/Msg";

const MenuItem = ({ item }) => {
  const { pathname } = useLocation();

  const onLinkClick = useCallback((e) => {
    const $body = $("body");
    const $html = $("html");

    const shouldRemoveClasses = !$body.hasClass("menu-on-top") || ($body.hasClass("menu-on-top") && $body.hasClass("mobile-view-activated"));

    if (shouldRemoveClasses) {
      $html.removeClass("hidden-menu-mobile-lock");
      $body.removeClass("hidden-menu minified");
    }
  }, []);
  const isActive = (item) => {
    if (item.route) {
      return item.route === pathname;
    }
    return false;
  };
  const title = !item.parent ? (
    <span className="menu-item-parent">
      <Msg phrase={item.title} />
    </span>
  ) : (
    <Msg phrase={item.title} />
  );
  const badge = item.badge ? <span className={item.badge.class}>{item.badge.label || ""}</span> : null;
  const childItems = item.items ? (
    <ul>
      {item.items.map((childItem) => {
        return <MenuItem item={childItem} key={childItem.id} />;
      })}
    </ul>
  ) : null;
  const icon = item.icon ? <i className={item.icon}>{item.counter && <em>{item.counter}</em>}</i> : null;
  const liClassName = isActive(item) ? "active" : "";
  const link = item.route ? (
    <NavLink to={item.route} title={item.title} className={null} onClick={onLinkClick}>
      {icon} {title} {badge}
    </NavLink>
  ) : (
    <a href={item.href || "#"} title={item.title}>
      {icon} {title} {badge}
    </a>
  );
  return (
    <li className={liClassName}>
      {link}
      {childItems}
    </li>
  );
};

MenuItem.propTypes = {
  item: PropTypes.object,
};

export default MenuItem;
